export default __webpack_public_path__ + "static/media/GennemgangAfDinFormue.d86577ad.svg";